import { IRegisterExitAction } from "./types/registerExitTypes";

export const fillListPeopleInside = (list: any[]): IRegisterExitAction<any> => {
  return {
    type: "FILL_LIST_PEOPLEINSIDE",
    payload: list,
  };
};

export const loadingScanPeopleInside = (
  value: boolean,
): IRegisterExitAction<any> => {
  return {
    type: "SET_LOADING_PEOPLEINSIDE_SCAN",
    payload: value,
  };
};

export const loadingSearchPeopleInside = (
  value: boolean,
): IRegisterExitAction<any> => {
  return {
    type: "SET_LOADING_PEOPLEINSIDE_SEARCH",
    payload: value,
  };
};

export const loadingSelectingPeopleInside = (
  value: boolean,
): IRegisterExitAction<any> => {
  return {
    type: "SET_LOADING_PEOPLEINSIDE_SELECTING",
    payload: value,
  };
};

export const setPaginationPage = (page: number): IRegisterExitAction<any> => {
  return {
    type: "SET_PAGINATION_PAGE",
    payload: page,
  };
};
export const setPageCount = (pageCount: number): IRegisterExitAction<any> => {
  return {
    type: "SET_PAGE_COUNT",
    payload: pageCount,
  };
};

export const setSearchValue = (
  searchValue: string,
): IRegisterExitAction<any> => {
  return {
    type: "SET_SEARCH_VALUE",
    payload: searchValue,
  };
};

export const setSortBy = (sortBy: string): IRegisterExitAction<any> => {
  return {
    type: "SET_SORT_BY",
    payload: sortBy,
  };
};

export const setSortByDirection = (
  sortByDirection: "asc" | "desc",
): IRegisterExitAction<any> => {
  return {
    type: "SET_SORT_BY_DIRECTION",
    payload: sortByDirection,
  };
};

export const setOpenedVehicleSection = (
  openedVehicleSection: boolean,
): IRegisterExitAction<any> => {
  return {
    type: "OPENED_VEHICLE_SECTION",
    payload: openedVehicleSection,
  };
};
